<h2 mat-dialog-title>
  {{ 'START_TRIAL_SUCCESS_MODAL.HEADING' | translate }}
</h2>
<mat-dialog-content>
  <p>
    {{ 'START_TRIAL_SUCCESS_MODAL.DESCRIPTION' | translate: { numDays: numDaysTrial } }}
  </p>
  <div class="fireworks"></div>
  <p class="rocket-emoji">🚀</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" mat-dialog-close>
    {{ 'COMMON.ACTION_LABELS.DONE' | translate }}
  </button>
</mat-dialog-actions>
